import React from 'react';

export const NO_ACTIVE_ACCOUNT = (
  <>
    No active account found – If you believe this is an error contact{' '}
    <a href="mailto:support@hmbradley.com">support@hmbradley.com</a>
  </>
);
